import { memo, useState, useMemo, useCallback } from "react";
import { ftmRequestStatus } from "../../../utils";
import RequestImageGallery from "./RequestImageGallery";
import FilesView from "../../../common/filesView/FilesView";

const RequestDetailsCard = memo(({ request, isAlert=false }) => {
    const getFtmRequestStatus = ({
        ftm_request_is_accept,
        ftm_request_is_pending,
        ftm_request_is_undecided,
    }) => {
        if (ftm_request_is_accept === 1) {
            return 1;
        }

        if (ftm_request_is_accept === -1) {
            return -1;
        }

        if (ftm_request_is_undecided === 1) {
            return 2;
        }

        if (ftm_request_is_pending === 1) {
            return 3;
        }

        return 0;
    };

    // ✅ derive status safely
    const status = useMemo(() => {
        const statusValue = getFtmRequestStatus(request);
        return ftmRequestStatus(statusValue);
    }, [request]);

    const { icon, color, text } = status;

    // ✅ state
    const [showFileViewModal, setShowFileViewModal] = useState(false);
    const [fileViewIndex, setFileViewIndex] = useState(0);

    // ✅ handlers (memoized)
    const handleFileViewOpen = useCallback((index) => {
        setFileViewIndex(index);
        setShowFileViewModal(true);
    }, []);

    const handleFileViewClose = useCallback(() => {
        setShowFileViewModal(false);
    }, []);

    // ✅ precompute files (avoid map in render)
    const files = useMemo(() => {
        if (!request?.ftm_request_images) return [];

        return request.ftm_request_images.map((item) => {
            const path = item?.ftm_request_image_path || "";
            return {
                preview: path,
                fileName: path.split("/").pop() || "file",
            };
        });
    }, [request?.ftm_request_images]);

    return (
        <div className="card mb-3">
            <div className="card-body p-3">
                {!isAlert && (
                    <div className="d-flex">
                        <i
                            className={`material-symbols-rounded text-${color}`}
                            style={{ fontSize: "40px" }}
                        >
                            {icon}
                        </i>

                        <div className="ms-2 my-auto">
                            <h6 className="mb-0">{text}</h6>
                            <p className="text-xs mb-0">
                                #{request?.ftm_request_id} 
                            </p>
                        </div>
                    </div>
                )}

                {/* Description */}
                <p className={`mt-${isAlert ? '3' : '1'} mb-${isAlert ? '0' : '2'} text-${isAlert ? 'sm' : 'md'}`}>
                    <b>Reason for request</b>
                </p>
                <p className="mt-0 text-sm">
                    {request?.ftm_request_description || "-"}
                </p>

                {/* Images */}
                <p className={`mt-3 mb-0 text-${isAlert ? 'sm' : 'md'}`}>
                    <b>Reason Images</b>
                </p>

                <div className={`mt-0 text-sm`}>
                    <RequestImageGallery
                        images={request?.ftm_request_images || []}
                        handleFileViewOpen={handleFileViewOpen}
                    />

                    <FilesView
                        show={showFileViewModal}
                        handleClose={handleFileViewClose}
                        title="Request details images"
                        files={files}
                        selectedId={fileViewIndex}
                    />
                </div>
            </div>
        </div>
    );
});

export default RequestDetailsCard;